export const FUND_INFO_CARD_TEXT = {
  duration: '존속기간',
  purpose: '펀드 목적',
} as const;
